import US_STATES_WITH_INITIALS from '../../../../us_states_and_initials';

const STATE_NAME_TO_CODE = Object.entries(US_STATES_WITH_INITIALS).reduce(
  (acc, [code, name]) => {
    acc[name.toLowerCase()] = code;
    return acc;
  },
  {}
);

export const normalizeLicenceState = (value) => {
  if (value === null || value === undefined) {
    return '';
  }

  const trimmed = String(value).trim();

  if (!trimmed || trimmed.toLowerCase() === 'null') {
    return '';
  }

  if (US_STATES_WITH_INITIALS[trimmed]) {
    return trimmed;
  }

  const upper = trimmed.toUpperCase();
  if (US_STATES_WITH_INITIALS[upper]) {
    return upper;
  }

  const byName = STATE_NAME_TO_CODE[trimmed.toLowerCase()];
  if (byName) {
    return byName;
  }

  return trimmed;
};

export const formatLicenceStateLabel = (value) => {
  const code = normalizeLicenceState(value);

  if (!code) {
    return '—';
  }

  return US_STATES_WITH_INITIALS[code] || code;
};

export const mergeVehicleFields = (...sources) => {
  const result = {};

  sources.forEach((source) => {
    if (!source || typeof source !== 'object') {
      return;
    }

    Object.keys(source).forEach((key) => {
      let value = source[key];

      if (key === 'licence_state') {
        value = normalizeLicenceState(value);
        // Allow explicit empty string to clear a previously saved state.
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          if (value !== undefined && value !== null) {
            result[key] = value;
          }
        }
        return;
      }

      if (value !== undefined && value !== null && value !== '') {
        result[key] = value;
      }
    });
  });

  return result;
};
